// TEMP_SIGNATURE_PREVIEW: temporary UI stubs. Removal: docs/ui-design/signature-preview.md.
import Vue from 'vue';

// TEMP_SIGNATURE_PREVIEW: switch here; hot reload applies changes without a server restart.
const TEMP_SIGNATURE_PREVIEW_ENABLED = false;
export const isSignaturePreview = process.env.NODE_ENV === 'development' && TEMP_SIGNATURE_PREVIEW_ENABLED;
export const isSignaturePreviewContext = (context) => isSignaturePreview && !!context?.previewUser;

const organizations = [
  { id: -101, name: 'МБОУ «Гимназия №5»', inn: '7701234567', kpp: '770101001' },
  { id: -102, name: 'АНО ЦРТ «Ориентир»', inn: '7701234567', kpp: '780201021' },
  { id: -103, name: 'МАУ ДО ДДТ «Радуга»', inn: '7701234567', kpp: '500101031' },
];
const state = Vue.observable({ user: null });
let nextRequestId = 9000;
const requestId = () => { nextRequestId += 1; return nextRequestId; };

const respond = async (data) => {
  const response = await Vue.prototype.$mock.request({ data, timer: 350 });
  return { response, item: response.data.data };
};
const fail = (message) => ({ error: Object.assign(new Error(message), { signatureClientError: true }) });
const account = () => {
  if (!state.user) throw Object.assign(new Error('Выберите тестовую организацию.'), { signatureClientError: true });
  return state.user;
};
const updateAccount = async ({ organizationId, isActive }, data, update) => {
  const user = account();
  const result = await respond(data);
  if (!isActive() || state.user !== user || user.organizer.id !== organizationId) return fail('Тестовая операция отменена.');
  update(user);
  return result;
};

export const signaturePreview = {
  certificates: [{
    thumbprint: 'TEMP_SIGNATURE_PREVIEW_CERTIFICATE',
    name: 'Тестовый сертификат УКЭП организации',
    issuer: 'Тестовый удостоверяющий центр',
    expiresAt: '2030-12-31T00:00:00Z',
  }],
  signature: {
    async authorize({ isActive }) {
      const result = await respond({ verification_token: 'TEMP_SIGNATURE_PREVIEW_PROOF', organizations });
      return isActive() ? result : fail('Тестовая операция отменена.');
    },
    async login({ data }) {
      const organization = organizations.find(({ id }) => id === data.organization_id);
      if (!organization || data.verification_token !== 'TEMP_SIGNATURE_PREVIEW_PROOF') return fail('Выберите тестовую организацию из списка.');
      state.user = {
        id: organization.id,
        username: `demo_organization_${Math.abs(organization.id)}`,
        organizer: { ...organization, contact_email: organization.id === -103 ? '' : 'demo@example.test' },
        change_emails: organization.id === -102 ? [{ id: requestId(), old: 'demo@example.test', new: 'pending@example.test', change_at: null }] : [],
      };
      return respond({ previewUser: state.user });
    },
    setupPassword(params) {
      return updateAccount(params, {}, () => {});
    },
  },
  accountSetup: {
    sendEmailChange(params) {
      if (account().change_emails.length) return Promise.resolve(fail('У вас уже есть заявка на смену email'));
      const pending = { id: requestId(), old: account().organizer.contact_email, new: params.data.email, change_at: null };
      return updateAccount(params, pending, (user) => { user.change_emails = [pending]; });
    },
    confirmEmailChange(params) {
      const pending = account().change_emails.find((item) => !item.change_at && item.new === params.data.email);
      if (!pending || params.data.code !== '123456') {
        params.obs?.setErrors({ code: ['Неверный код подтверждения.'] });
        return Promise.resolve(fail('Неверный код подтверждения.'));
      }
      const confirmed = { ...pending, change_at: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString() };
      return updateAccount(params, confirmed, (user) => { user.change_emails = [confirmed]; });
    },
    setOrganizationEmail(params) {
      return updateAccount(params, {}, (user) => { user.organizer.contact_email = params.data.email; });
    },
    removeEmailChange(params) {
      return updateAccount(params, {}, (user) => { user.change_emails = user.change_emails.filter(({ id }) => id !== params.args[0]); });
    },
  },
};
